import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useDeleteNIS = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const deleteNIS = async (id) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
  const response = await axiosApi.delete(`/nis/delete/${id}`);
      setSuccessMessage(response.data.message || 'Deleted successfully');
      console.log(`Deleted NIS data with id: ${id}`);
      return response.data; // Return response data for caller if needed
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete NIS');
      console.error('Delete error:', err);
    } finally {
      setLoading(false);
    }
  };

  return { deleteNIS, loading, error, successMessage };
};

export default useDeleteNIS;
